module.exports = __webpack_public_path__ + "static/media/RG_330.c9ef1759.png";